// Auto-import all JSON files from Decap CMS.
const cmsContext = require.context('./cms/team', false, /\.json$/);
const cmsTeam = cmsContext.keys().map((key) => {
  const data = cmsContext(key);
  return {
    id: data.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''),
    name: data.name,
    title: data.title,
    photo: data.photo ?? null,
    quote: data.quote ?? '',
    order: data.order ?? 99,
  };
});

export const teamMembers = cmsTeam.sort((a, b) => a.order - b.order);
